export interface PlanogramPerformanceRecord {
  psaRecordIndex: number;
  rawRecord?: string;
  upc: string;
  dbTime: Date; // not in PSA Headers spreadsheet
  dbUser: string; // not in PSA Headers spreadsheet
  dbParentPlanogramKey: number; // not in PSA Headers spreadsheet
  dbParentProductKey: number; // not in PSA Headers spreadsheet
  dbKey: number; // "key" in PSA Headers spreadsheet
  changed: number; // Calculated Internally
  field3: string;
  price: number;
  caseCost: number;
  taxCode: number;
  unitMovement: number;
  share: number;
  facings: number; // Calculated Internally
  desc1: string; // Comment
  desc2: string; // AsstStatus
  desc3: string;
  desc4: string;
  desc5: string;
  desc6: string;
  desc7: string; // SRR Date
  desc8: string;
  desc9: string;
  desc10: string; // PreviouslyUnallocated
  value1: number; // Store Unit Mvmt
  value2: number; // Peak Holding Mvmt
  value3: number; // Cluster CSV Unit Mvmt
  value4: number; // Avg Sales
  value5: number; // GP Dollars
  value6: number; // Cluster CSV Unit Cost
  value7: number; // Store Unit Price
  value8: number; // Store CSV Unit Price
  value9: number; // Cluster CSV Unit Price
  value10: number; // BI Import 1
  flag1: number; // Relocate
  flag2: number; // SRR - Store Requested Remove
  flag3: number; // AsstHasNoRecFacings
  flag4: number; // AsstHadFacings
  flag5: number; // AsstAddedToPog
  flag6: number; // AsstFoundInFile
  flag7: number; // Free Track
  flag8: number; // Paddle
  flag9: number; // Half Track
  flag10: number; // SRS Order
  salesPrcnt: number; // Calculated Internally
  desc11: string; // RESERVED FOR ASSORTMENT IMPORT ESP
  desc12: string; // SRR Comment
  desc13: string; // RESERVED FOR MOVEMENT IMPORT DATE FIELD
  desc14: string;
  desc15: string;
  desc16: string;
  desc17: string;
  desc18: string;
  desc19: string;
  desc20: string;
  desc21: string;
  desc22: string;
  desc23: string;
  desc24: string;
  desc25: string;
  desc26: string;
  desc27: string;
  desc28: string;
  desc29: string;
  desc30: string;
  units: number; // Calculated Internally
  capacity: number; // Calculated Internally
  linear: number; // Calculated Internally
  square: number; // Calculated Internally
  cubic: number; // Calculated Internally
  sales: number; // Calculated Internally
  unitCost: number;
  unitProfit: number; // Calculated Internally
  profit: number; // Calculated Internally
  salesLinear: number; // Calculated Internally
  salesSquare: number; // Calculated Internally
  salesCubic: number; // Calculated Internally // Calculated Internally
  profitLinear: number; // Calculated Internally
  profitSquare: number; // Calculated Internally
  profitCubic: number; // Calculated Internally
  movementLinear: number; // Calculated Internally
  movementSquare: number; // Calculated Internally
  movementCubic: number; // Calculated Internally
  turns: number; // Calculated Internally
  movementPrcnt: number; // Calculated Internally
  profitPrcnt: number; // Calculated Internally
  linearPrcnt: number; // Calculated Internally
  squarePrcnt: number; // Calculated Internally
  cubicPrcnt: number; // Calculated Internally
  linearPrcntUsed: number; // Calculated Internally
  squarePrcntUsed: number; // Calculated Internally
  cubicPrcntUsed: number; // Calculated Internally
  value1Prcnt: number; // Calculated Internally
  value2Prcnt: number; // Calculated Internally
  value3Prcnt: number; // Calculated Internally
  actualCaseMultiple: number; // Calculated Internally
  actualDaysSupply: number; // Calculated Internally
  targetInventory: number; // Calculated Internally
  targetInventoryMerch: number; // Calculated Internally
  roiICost: number; // Calculated Internally
  roiIRetail: number; // Calculated Internally
  capacityCost: number; // Calculated Internally
  capacityRetail: number; // Calculated Internally
  costBeforeTax: number; // Calculated Internally
  assortmentNote: string;
  desc31: string;
  desc32: string;
  desc33: string;
  desc34: string;
  desc35: string;
  desc36: string;
  desc37: string;
  desc38: string;
  desc39: string;
  desc40: string;
  desc41: string;
  desc42: string;
  desc43: string;
  desc44: string;
  desc45: string;
  desc46: string;
  desc47: string;
  desc48: string;
  desc49: string;
  desc50: string;
  priceBeforeTax: number; // Calculated Internally
  annualMovement: number; // Calculated Internally
  annualProfit: number; // Calculated Internally
  overstock: number; // Calculated Internally
  combinedPerformanceIndex: number;
  value11: number; // AsstRecFacings
  value12: number; // AsstRecHFacings
  value13: number; // AsstRecVFacings
  value14: number; // AsstClusterMvmt
  value15: number; // AsstClusterRank
  value16: number; // SRS Order Point
  value17: number; // BI Import 2
  value18: number; // BI Import 3
  value19: number; // BI Import 4
  value20: number; // BI Import 5
  value21: number; // Avg Mvmt
  value22: number; // Pct Shrink Units
  value23: number; // Pct Shrink Sales
  value24: number;
  value25: number;
  value26: number;
  value27: number;
  value28: number;
  value29: number;
  value30: number;
  caseMultiple: number;
  daysSupply: number;
  peakSafetyFactor: number;
  backroomStock: number;
  minimumUnits: number;
  maximumUnits: number;
  deliverySchedule: string;
  replenishmentMax: number;
  replenishmentMin: number;
  cpiRank: number; // assortment_rank in Psa Headers Spreadsheet
  recommendedFacings: number;
  assortmentStrategy: string;
  assortmentTactic: string;
  assortmentReason: string;
  assortmentAction: string;
  partId: string;
  numberOfPositions: number; // Calculated Internally
  clusterName: string;
  targetDistributionStores: number;
  targetDistributionPrcnt: number;
  value31: number;
  value32: number; // WIC Reported to State
  value33: number;
  value34: number;
  value35: number;
  value36: number;
  value37: number;
  value38: number;
  value39: number;
  value40: number;
  value41: number;
  value42: number;
  value43: number;
  value44: number;
  value45: number;
  value46: number;
  value47: number;
  value48: number;
  value49: number;
  value50: number;
  capacityUnrestricted: number; // Calculated Internally
  customData: string;
  recommendedOrientation: number;
  recommendedMerchStyle: number;
  ignoreRecommendations: number;
  priority: number;
  priorityDesc: string;
  forceList: number;
  pgReasons: string;
  pgMaxStageReduce: number;
  pgMaxStageFillOut: number;
  assortmentCdt: number; // not in Object Mapping Spreadsheet --- TODO column is number in DB so forcing to number into DB in Converter, need checked
  serviceLevel: number; // not in Object Mapping Spreadsheet
  demandMean: number; // not in Object Mapping Spreadsheet
  demandStandardDeviation: number; // not in Object Mapping Spreadsheet
  recommendedChange: number; // not in Object Mapping Spreadsheet   ---- TODO column is number in DB so forcing to number into DB in Converter, need checked
  actualServiceLevel: number; // not in Object Mapping Spreadsheet
}

export const planogramPerformanceRecordValidation = {
  upc: "VARCHAR",
  dbParentProductKey: "BIGINT", // "key" in PSA Headers spreadsheet
  changed: "INT", // Calculated Internally
  price: "NUMERIC", // NUMERIC(20, 4),
  caseCost: "NUMERIC", // NUMERIC(20, 4),
  taxCode: "INT",
  unitMovement: "NUMERIC",
  share: "NUMERIC",
  facings: "INT", // Calculated Internally
  desc1: "VARCHAR", // Comment
  desc2: "VARCHAR", // AsstStatus
  desc3: "VARCHAR",
  desc4: "VARCHAR",
  desc5: "VARCHAR",
  desc6: "VARCHAR",
  desc7: "VARCHAR", // SRR Date
  desc8: "VARCHAR",
  desc9: "VARCHAR",
  desc10: "VARCHAR", // PreviouslyUnallocated
  value1: "NUMERIC", // Store Unit Mvmt
  value2: "NUMERIC", // Peak Holding Mvmt
  value3: "NUMERIC", // Cluster CSV Unit Mvmt
  value4: "NUMERIC", // Avg Sales
  value5: "NUMERIC", // GP Dollars
  value6: "NUMERIC", // Cluster CSV Unit Cost
  value7: "NUMERIC", // Store Unit Price
  value8: "NUMERIC", // Store CSV Unit Price
  value9: "NUMERIC", // Cluster CSV Unit Price
  value10: "NUMERIC", // BI Import 1
  flag1: "INT", // Relocate
  flag2: "INT", // SRR - Store Requested Remove
  flag3: "INT", // AsstHasNoRecFacings
  flag4: "INT", // AsstHadFacings
  flag5: "INT", // AsstAddedToPog
  flag6: "INT", // AsstFoundInFile
  flag7: "INT", // Free Track
  flag8: "INT", // Paddle
  flag9: "INT", // Half Track
  flag10: "INT", // SRS Order
  salesPrcnt: "NUMERIC", // Calculated Internally
  desc11: "VARCHAR", // RESERVED FOR ASSORTMENT IMPORT ESP
  desc12: "VARCHAR", // SRR Comment
  desc13: "VARCHAR", // RESERVED FOR MOVEMENT IMPORT DATE FIELD
  desc14: "VARCHAR",
  desc15: "VARCHAR",
  desc16: "VARCHAR",
  desc17: "VARCHAR",
  desc18: "VARCHAR",
  desc19: "VARCHAR",
  desc20: "VARCHAR",
  desc21: "VARCHAR",
  desc22: "VARCHAR",
  desc23: "VARCHAR",
  desc24: "VARCHAR",
  desc25: "VARCHAR",
  desc26: "VARCHAR",
  desc27: "VARCHAR",
  desc28: "VARCHAR",
  desc29: "VARCHAR",
  desc30: "VARCHAR",
  units: "INT", // Calculated Internally
  capacity: "INT", // Calculated Internally
  linear: "NUMERIC", // Calculated Internally
  square: "NUMERIC", // Calculated Internally
  cubic: "NUMERIC", // Calculated Internally
  sales: "NUMERIC", // Calculated Internally
  unitCost: "NUMERIC",
  unitProfit: "NUMERIC", // Calculated Internally
  profit: "NUMERIC", // Calculated Internally
  salesLinear: "NUMERIC", // Calculated Internally
  salesSquare: "NUMERIC", // Calculated Internally
  salesCubic: "NUMERIC", // Calculated Internally // Calculated Internally
  profitLinear: "NUMERIC", // Calculated Internally
  profitSquare: "NUMERIC", // Calculated Internally
  profitCubic: "NUMERIC", // Calculated Internally
  movementLinear: "NUMERIC", // Calculated Internally
  movementSquare: "NUMERIC", // Calculated Internally
  movementCubic: "NUMERIC", // Calculated Internally
  turns: "NUMERIC", // Calculated Internally
  movementPrcnt: "NUMERIC", // Calculated Internally
  profitPrcnt: "NUMERIC", // Calculated Internally
  linearPrcnt: "NUMERIC", // Calculated Internally
  squarePrcnt: "NUMERIC", // Calculated Internally
  cubicPrcnt: "NUMERIC", // Calculated Internally
  linearPrcntUsed: "NUMERIC", // Calculated Internally
  squarePrcntUsed: "NUMERIC", // Calculated Internally
  cubicPrcntUsed: "NUMERIC", // Calculated Internally
  value1Prcnt: "NUMERIC", // Calculated Internally
  value2Prcnt: "NUMERIC", // Calculated Internally
  value3Prcnt: "NUMERIC", // Calculated Internally
  actualCaseMultiple: "NUMERIC", // Calculated Internally
  actualDaysSupply: "NUMERIC", // Calculated Internally
  targetInventory: "INT", // Calculated Internally
  targetInventoryMerch: "INT", // Calculated Internally
  roiICost: "NUMERIC", // Calculated Internally
  roiIRetail: "NUMERIC", // Calculated Internally
  capacityCost: "NUMERIC", // Calculated Internally
  capacityRetail: "NUMERIC", // Calculated Internally
  costBeforeTax: "NUMERIC", // Calculated Internally
  assortmentNote: "VARCHAR",
  desc31: "VARCHAR",
  desc32: "VARCHAR",
  desc33: "VARCHAR",
  desc34: "VARCHAR",
  desc35: "VARCHAR",
  desc36: "VARCHAR",
  desc37: "VARCHAR",
  desc38: "VARCHAR",
  desc39: "VARCHAR",
  desc40: "VARCHAR",
  desc41: "VARCHAR",
  desc42: "VARCHAR",
  desc43: "VARCHAR",
  desc44: "VARCHAR",
  desc45: "VARCHAR",
  desc46: "VARCHAR",
  desc47: "VARCHAR",
  desc48: "VARCHAR",
  desc49: "VARCHAR",
  desc50: "VARCHAR",
  priceBeforeTax: "NUMERIC", // Calculated Internally
  annualMovement: "NUMERIC", // Calculated Internally
  annualProfit: "NUMERIC", // Calculated Internally
  overstock: "INT", // Calculated Internally
  combinedPerformanceIndex: "NUMERIC",
  value11: "NUMERIC", // AsstRecFacings
  value12: "NUMERIC", // AsstRecHFacings
  value13: "NUMERIC", // AsstRecVFacings
  value14: "NUMERIC", // AsstClusterMvmt
  value15: "NUMERIC", // AsstClusterRank
  value16: "NUMERIC", // SRS Order Point
  value17: "NUMERIC", // BI Import 2
  value18: "NUMERIC", // BI Import 3
  value19: "NUMERIC", // BI Import 4
  value20: "NUMERIC", // BI Import 5
  value21: "NUMERIC", // Avg Mvmt
  value22: "NUMERIC", // Pct Shrink Units
  value23: "NUMERIC", // Pct Shrink Sales
  value24: "NUMERIC",
  value25: "NUMERIC",
  value26: "NUMERIC",
  value27: "NUMERIC",
  value28: "NUMERIC",
  value29: "NUMERIC",
  value30: "NUMERIC",
  caseMultiple: "NUMERIC",
  daysSupply: "NUMERIC",
  peakSafetyFactor: "NUMERIC",
  backroomStock: "NUMERIC",
  minimumUnits: "INT",
  maximumUnits: "INT",
  deliverySchedule: "VARCHAR",
  replenishmentMax: "INT",
  replenishmentMin: "INT",
  cpiRank: "INT", // assortment_rank in Psa Headers Spreadsheet
  recommendedFacings: "INT",
  assortmentStrategy: "VARCHAR",
  assortmentTactic: "VARCHAR",
  assortmentReason: "VARCHAR",
  assortmentAction: "VARCHAR",
  partId: "VARCHAR",
  numberOfPositions: "INT", // Calculated Internally
  clusterName: "VARCHAR",
  targetDistributionStores: "INT",
  targetDistributionPrcnt: "NUMERIC",
  value31: "NUMERIC",
  value32: "NUMERIC", // WIC Reported to State
  value33: "NUMERIC",
  value34: "NUMERIC",
  value35: "NUMERIC",
  value36: "NUMERIC",
  value37: "NUMERIC",
  value38: "NUMERIC",
  value39: "NUMERIC",
  value40: "NUMERIC",
  value41: "NUMERIC",
  value42: "NUMERIC",
  value43: "NUMERIC",
  value44: "NUMERIC",
  value45: "NUMERIC",
  value46: "NUMERIC",
  value47: "NUMERIC",
  value48: "NUMERIC",
  value49: "NUMERIC",
  value50: "NUMERIC",
  capacityUnrestricted: "INT", // Calculated Internally
  customData: "VARCHAR",
  recommendedOrientation: "INT",
  recommendedMerchStyle: "INT",
  ignoreRecommendations: "BIT",
  priority: "INT",
  priorityDesc: "VARCHAR",
  forceList: "INT",
  pgReasons: "VARCHAR",
  pgMaxStageReduce: "NUMERIC",
  pgMaxStageFillOut: "NUMERIC",
  assortmentCdt: "NUMERIC", // not in Object Mapping Spreadsheet --- TODO column is number in DB so forcing to number into DB in Converter, need checked
  serviceLevel: "INT", // not in Object Mapping Spreadsheet
  demandMean: "NUMERIC", // not in Object Mapping Spreadsheet
  demandStandardDeviation: "NUMERIC", // not in Object Mapping Spreadsheet
  recommendedChange: "INT", // not in Object Mapping Spreadsheet   ---- TODO column is number in DB so forcing to number into DB in Converter, need checked
  actualServiceLevel: "INT", // not in Object Mapping Spreadsheet
} satisfies { [key: string]: "INT" | "BIGINT" | "NUMERIC" | "BIT" | "VARCHAR" };

export const performanceHeaders = Object.keys(planogramPerformanceRecordValidation);
